angular.module('homebot.directives')
.directive('autosize', function(){
  return {
    restrict: 'A',
    link: function(scope, el, attrs, undefined){
      _.defer(() => { autosize(el[0])});
    }
  }
});
